<template>
  <div>
    <Form ref="searchForm" :label-width="110">
      <Row style="margin-top: 8px">
        <i-col
          :span="span ? span : 6"
          v-for="(data, index) in dataList"
          :key="index"
          style="height: 46px"
        >
          <FormItem v-if="data.type === 'select'" :label="data.label + '：'">
            <Select
              id="select"
              v-model="searchInfo[data.key]"
              clearable
              :disabled="data.disabled"
              @on-change="(value)=>{_onChange(data.key, value)}"
            >
              <Option
                v-for="item in data.options"
                :value="item.key"
                :key="item.key"
              >{{ item.label }}</Option>
            </Select>
          </FormItem>

          <FormItem v-else-if="data.type === 'treeSelect'" :label="data.label + '：'">
            <treeselect
              :options="data.options"
              :load-options="data.loadOptions"
              v-model="searchInfo[data.key]"
              placeholder="请选择"
              :disabled="data.disabled"
            />
          </FormItem>

          <FormItem
            v-else-if="data.type === 'date' || data.type === 'datetime' || data.type === 'daterange' || data.type === 'datetimerange'"
            :label="data.label + '：'"
          >
            <DatePicker
              :type="data.type"
              show-week-numbers
              placeholder="请选择"
              v-model="tempSearchInfo[data.key + data.key2]"
              @on-change="(value)=>{dataOnChange(value, data)}"
              :disabled="data.disabled"
            />
          </FormItem>

          <FormItem v-else :label="data.label + '：'">
            <Input
              type="text"
              v-model="searchInfo[data.key]"
              @keydown.enter.native="search"
              clearable
              placeholder="请输入"
              :disabled="data.disabled"
            />
          </FormItem>
        </i-col>

        <div>
          <Button type="success" icon="ios-search" @click="search" @keyup.enter="search" style="margin-left:20px">搜索</Button>
          <Button
            type="primary"
            v-if="refreshBtn == true"
            icon="md-refresh"
            @click="this.refresh"
          >刷新</Button>
          <Button v-if="resetBtn != false" icon="md-refresh" @click="reset">重置</Button>
          <Button
            type="primary"
            v-if="exportBtn == true"
            icon="ios-exit-outline"
            @click="this.export"
          >导出</Button>
        </div>
      </Row>
    </Form>
  </div>
</template>
<script>
import "@riophae/vue-treeselect/dist/vue-treeselect.css";
import Treeselect from "@riophae/vue-treeselect";
export default {
  props: [
    "dataList", // 数据
    "onSearch", // 搜索回调
    "onChange", // 回调
    "span",
    "resetBtn",
    "exportBtn", //导出按钮
    "export", //导出按钮
    "refreshBtn", //刷新按钮
    "refresh" //刷新按钮
  ],
  components: {
    Treeselect
  },
  data() {
    return {
      searchInfo: {},
      tempSearchInfo: {}
    };
  },
  created(){
    this.keyupEnter()
  },
  methods: {
    keyupEnter(){
        document.onkeydown = e =>{
            let body = document.getElementsByTagName('body')[0]
            if (e.keyCode === 13 && e.target === body) {
              this.search();
            }
        }
    },
    //重置
    reset() {
      this.dataList.forEach(item => {
        this.searchInfo[item.key] = "";
        if (item.key2) this.searchInfo[item.key2] = "";
      });
      this.tempSearchInfo = {};
    },
    //搜索
    search() {
      //清除前后空格
      Object.keys(this.searchInfo).forEach(key => {
        if (typeof this.searchInfo[key] == "string") {
          this.searchInfo[key] = this.searchInfo[key].trim();
        }
      });
      this.onSearch(this.searchInfo);
    },
    // 获取筛选数据
    getSearchInfo() {
      return this.searchInfo;
    },
    // 设置筛选数据
    setSearchInfo(searchInfo) {
      this.searchInfo = { ...searchInfo };
      this.tempSearchInfo = { ...searchInfo };
    },
    _onChange(key, value) {
      this.onChange && this.onChange({ key, value });
    },
    dataOnChange(value, data) {
      if (data.type === "date" || data.type === "datetime") {
        this.searchInfo[data.key] = value;
        this.tempSearchInfo[data.key + data.key2] = value;
      } else if (data.type === "daterange" || data.type === "datetimerange") {
        this.searchInfo[data.key] = value[0];
        this.searchInfo[data.key2] = value[1];
        this.tempSearchInfo[data.key + data.key2] = value;
      }
    }
  }
};
</script>
<style>
.ivu-date-picker {
  width: 100%;
}
.control {
  display: flex;
  justify-content: flex-end;
}
</style>



// WEBPACK FOOTER //
// src/components/SearchForm/index.vue